// Generated by CoffeeScript 2.7.0
var TagGroupSidebar;

import TagsModal from 'trunks/vue/admin/compositions/tags_modal.js';

export default TagGroupSidebar = {
  __bindEditTags: function(type = 'receipt') {
    return document.body.proxy('click', '.js-open-edit-tags-modal-btn', function(event) {
      return Skylark.Libs.Ajax.get(Skylark.Helpers.UrlHelper.adminUrlFor(`tag_groups/${type}`), {
        responseType: 'json',
        success: function(tag_groups) {
          return $currentController.tags_modal = new TagsModal({
            el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('tags_modal'),
            propsData: {
              rawTagGroups: tag_groups,
              updateUrl: Skylark.Helpers.UrlHelper.adminUrlFor(`tag_groups/${type}/update_collection`, $currentController.getParams())
            }
          });
        },
        error: function() {
          return Skylark.Bridge.newAlertify('数据加载失败', {
            type: 'danger'
          });
        }
      });
    });
  },
  _updateTagNavGroup: function(content) {
    return DomMaster.find('#js_tag_nav_group').replaceWith(content);
  }
};
